import React from 'react';

import Select from 'react-select';

import { ITee } from '../../../../../store/admin/courses/store';

import { selectorTheme } from '../../../../../contrib/utils';
import { ITeeOption } from './Utils/getTeesOptions';
import { SelectedTee } from './SelectedTee/SelectedTee';

interface IProps {
  editMode: boolean;
  flightId: number;
  onEdit: any;
  options: ITeeOption[];
  tee?: ITee;
}

export const TeeSelector = ({ editMode, flightId, onEdit, tee, options }: IProps) => {
  const selected = tee && options.find(option => option.value.id === tee.id);

  return !editMode && tee ? (
    <SelectedTee onSelect={onEdit} flightId={flightId} tee={tee} />
  ) : (
    <Select
      value={selected || null}
      className="autocomplete"
      classNamePrefix="autocomplete"
      placeholder={'Select a Teebox'}
      onChange={onEdit}
      options={options}
      theme={selectorTheme}
    />
  );
};
